import React from "react";
import { useTranslation } from "react-i18next";


const HeroSection = () => {
  const { t, i18n } = useTranslation("team"); // Hook to use translations
  const isRussian = i18n.language === "ru"; // Check if the language is Russian


  return (
    <div className="meetSection py-28 md:pt-[140px] px-5 sm:px-10 xl:pl-[140px] md:pb-[387px]">
      <div className="flex flex-col justify-start items-start sm:gap-5 container-class">
        <div className="max-w-[818px]">
          <h1 className={`web-heading-main text-2xl md:text-4xl ${isRussian ? 'lang-ru-web-heading-main' : ''}   `}>
            {t("meet_our_team_title")}</h1>
          <p className="text-color body-xl md:text-xl max-w-5xl py-[20px] text-sm">
            {t("meet_our_team_description")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
